import { useMemo } from "react";
import GatheringPhotosFilter from "src/api/graphql/__generated__/enums/GatheringPhotosFilter";
import PhotoVariant from "src/api/graphql/__generated__/enums/PhotoVariant";
import ValidCaptureTimeViewModes from "../constants/ValidCaptureTimeViewModes";
import useGatheringStore from "./useGatheringStore";

const useParseFilterAndSortOptionsFromGatheringContext = () => {
	const filterUserIds = useGatheringStore((state) => state.filterUserIds);
	const filterUploaderIds = useGatheringStore((state) => state.filterUploaderIds);
	const _filterPhotoVariant = useGatheringStore((state) => state.filterPhotoVariant);
	const filterLabels = useGatheringStore((state) => state.filterLabels);
	const filterRestrictedLabels = useGatheringStore((state) => state.filterRestrictedLabels);

	// Filtering for 'Photos' implicitly includes 'Live Photos' (if you have a problem with this talk to @weilync)
	const filterPhotoVariant = useMemo(() => {
		if (
			_filterPhotoVariant?.includes(PhotoVariant.Image) &&
			!_filterPhotoVariant.includes(PhotoVariant.LivePhoto)
		) {
			return [..._filterPhotoVariant, PhotoVariant.LivePhoto];
		}
		return _filterPhotoVariant;
	}, [_filterPhotoVariant]);

	const viewMode = useGatheringStore((state) => state.viewMode);
	const sortMode = useGatheringStore((state) => state.sortMode);
	const photoOptions = useMemo<{
		filter: GatheringPhotosFilter;
		filterUserIds?: string[];
		filterUploaderIds?: string[];
		filterPhotoVariant?: PhotoVariant[];
		filterLabels?: string[];
		filterRestrictedLabels?: string[];
	}>(() => {
		switch (viewMode) {
			case "AllCaller":
				return {
					filter: GatheringPhotosFilter.AllCaller,
				};
			case "Hidden":
				return {
					filter: GatheringPhotosFilter.Hidden,
				};
			default:
				if (sortMode === "CaptureTime" && ValidCaptureTimeViewModes.has(viewMode)) {
					return {
						filter: GatheringPhotosFilter.ActiveCaptureSort,
						filterUserIds,
						filterUploaderIds,
						filterPhotoVariant,
						filterLabels,
						filterRestrictedLabels,
					};
				} else {
					return {
						filter: GatheringPhotosFilter.Active,
						filterUserIds: filterUserIds,
						filterUploaderIds,
						filterPhotoVariant,
						filterLabels,
						filterRestrictedLabels,
					};
				}
		}
	}, [
		filterUserIds,
		filterUploaderIds,
		filterPhotoVariant,
		viewMode,
		sortMode,
		filterLabels,
		filterRestrictedLabels,
	]);

	return photoOptions;
};
export default useParseFilterAndSortOptionsFromGatheringContext;
